import { GnbFooter, LectureCardInReservation } from "../../shared"
import dayjs from "dayjs";
import { useDispatch, useSelector, useStore } from "react-redux";
import { RootState } from "../../modules";
import WellnessLectureSkeleton from "../../components/skeleton/reservation/wellnessLectureSkeleton";
import { useGetAllWellnessLectureByYogaCenterIdAndMemberIdAndStartDateTimeBetweenAndIsDeleteFalse, useGetProgramListWeb, yogaCenterRadioOptionList } from "./model";
import { useEffect, useRef, useState } from "react";
import { Flex } from "antd";
import { ThunkDispatch } from "redux-thunk";
import { getSelectedYogaCenteAndDaterAsync } from "../../modules/selectedYogaCenterAndDate";
import { useMyContext } from "../../entities/context";
import ReservationSkeleton from "../../components/skeleton/reservation/reservationSkeleton";
import { useLocation } from "react-router-dom";
import { WellnessProgramContainer } from "../wellnessProgram/ui/container";
import { getMonthDaysForToday, getWeekPage, toSelectableDate } from "./calendar";

const Explore = () => {
    const { yogaCenterId, date } = useSelector((state: RootState) => state.selectedYogaCenterAndDate);
    const store = useStore<RootState>();
    const monthDaysContainerRef = useRef<HTMLDivElement | null>(null);
    const sevenCollectRef = useRef<HTMLDivElement | null>(null);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const paramId = searchParams.get("id");
    const paramDate = searchParams.get("date");
    const dispatch: ThunkDispatch<any, any, any> = useDispatch();
    const update = getSelectedYogaCenteAndDaterAsync;
    const { topHeight } = useMyContext();
    const [initLoading, setInitLoading] = useState<boolean>(true);
    const { data: wellnessLectures, isLoading: isFetchingLectures, isSuccess } = useGetAllWellnessLectureByYogaCenterIdAndMemberIdAndStartDateTimeBetweenAndIsDeleteFalse(yogaCenterId, dayjs(date), dayjs(date))
    const responseQuery = "id title thumbnailImageUrl programPeriod bookingPeriod locationName displayIdx isDisableBooking isOnline"
    const { data: programWebList, isLoading } = useGetProgramListWeb(responseQuery)
    const monthDays = getMonthDaysForToday();
    const selectedPage = getWeekPage(date);
    const [currentPage, setCurrentPage] = useState(selectedPage);
    const [syncedPage, setSyncedPage] = useState(selectedPage);
    const [dragStartX, setDragStartX] = useState<number | null>(null);
    const [dragOffset, setDragOffset] = useState(0);

    if (selectedPage !== syncedPage) {
        setSyncedPage(selectedPage);
        setCurrentPage(selectedPage);
    }

    const handleStart = (e: React.TouchEvent | React.MouseEvent) => {
        const clientX = "touches" in e ? e.touches[0].clientX : e.clientX;
        setDragStartX(clientX);
    };

    const handleMove = (e: React.TouchEvent | React.MouseEvent) => {
        if (dragStartX === null) return;
        const clientX = "touches" in e ? e.touches[0].clientX : e.clientX;
        const offset = clientX - dragStartX;
        const maxOffset = (sevenCollectRef.current?.getBoundingClientRect().width ?? 355)
        setDragOffset(offset > maxOffset ? maxOffset : offset < -maxOffset ? -maxOffset : offset);
    };

    const handleEnd = () => {
        if (dragStartX === null) return;

        if (dragOffset > 50 && currentPage > 0) {
            setCurrentPage(currentPage - 1);
        } else if (dragOffset < -50 && currentPage < monthDays.length - 1) {
            setCurrentPage(currentPage + 1);
        }

        setDragStartX(null);
        setDragOffset(0);
    };

    const totalOffset = -(currentPage * (sevenCollectRef.current?.getBoundingClientRect().width ?? 355)) + dragOffset;

    useEffect(() => {
        const selectedDate = toSelectableDate(paramDate);
        if (!paramId && !selectedDate) return;

        const selected = store.getState().selectedYogaCenterAndDate;
        dispatch(update({
            yogaCenterId: paramId ? Number(paramId) : selected.yogaCenterId,
            date: selectedDate ?? selected.date,
        }));
    }, [paramId, paramDate, dispatch, update, store]);


    useEffect(() => {
        if (isSuccess) {
            setInitLoading(false);
        }
    }, [isSuccess]);

    return <>
        {initLoading && <ReservationSkeleton />}
        <div style={{ paddingTop: topHeight + 'px' }}></div>
        <div style={{ marginBottom: programWebList && programWebList.length > 0 ? '40px' : '24px' }}>
            <div className="sub-title/st4" style={{ paddingTop: '16px', paddingLeft: 20, color: 'var(--secondarys800)' }}>프로그램</div>
            {programWebList && programWebList.length > 0 &&
                <WellnessProgramContainer dataList={programWebList.map(program => ({
                    id: program.id,
                    title: program.title,
                    thumbnailImageUrl: program.thumbnailImageUrl,
                    programPeriod: program.programPeriod,
                    bookingPeriod: program.bookingPeriod,
                    locationName: program.locationName,
                    isDisableBooking: program.isDisableBooking,
                    isOnline: program.isOnline
                }))} />}
        </div>

        <div className="sub-title/st3" style={{ paddingLeft: 20, marginBottom: 24 }}>정규 클래스</div>

        <div style={{ display: 'flex', overflow: 'hidden' }} ref={monthDaysContainerRef}
            onTouchStart={handleStart}
            onTouchMove={handleMove}
            onTouchEnd={handleEnd}
            onMouseDown={handleStart}
            onMouseMove={(e) => {
                if (dragStartX !== null) e.preventDefault();
                handleMove(e);
            }}
            onMouseUp={handleEnd}
            onMouseLeave={handleEnd}
        >
            <div
                style={{
                    display: "flex",
                    transform: `translateX(calc(${totalOffset}px ))`,
                    transition: dragStartX === null ? "transform 0.3s ease" : "none",
                }}
            >
                {monthDays.map((sevenCollect, idx) =>
                    <div key={idx} style={{ display: 'flex', width: 'calc(100vw - 40px)', maxWidth: '440px', justifyContent: 'space-between', paddingInline: '20px', overflow: 'hidden' }} ref={idx === 0 ? sevenCollectRef : null}>
                        {sevenCollect.map((day, idx) =>
                            <div key={idx} role="button" tabIndex={0}
                                aria-label={day.isoDate}
                                aria-current={date === day.isoDate ? 'date' : undefined}
                                onClick={() => dispatch(update({ yogaCenterId: yogaCenterId, date: day.isoDate }))} style={{ textAlign: 'center' }}
                            >
                                <div className="sub-title/st1" style={{ width: 'auto', color: "var(--secondarys500)" }}>
                                    {dayjs().format("YYYY-MM-DD") === day.isoDate ? '오늘' : day.weekday}
                                </div>
                                <div className="body/b3" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginTop: 4,
                                    textAlign: "center",
                                    color: "var(--secondarys800)",
                                    backgroundColor: date === day.isoDate ? "#FFF743" : day.isoDate === dayjs().format("YYYY-MM-DD") ? "var(--secondarys100)" : undefined,
                                    borderRadius: "45%",
                                    cursor: "pointer",
                                    width: 36,
                                    height: 36,
                                }}>
                                    {day.dayOfMonth}
                                </div>
                            </div>)}
                    </div>)}
            </div>
        </div>

        <div style={{ padding: '0 20px 40px' }}>
            <Flex style={{ marginBlock: 20 }}>
                {yogaCenterRadioOptionList.map(({ id, label }) =>
                    <div key={id} onClick={() => dispatch(update({ yogaCenterId: id, date }))} className={"body/b2 " + (yogaCenterId === id ? 'secondary/s100' : 'secondary/s600')} style={{ padding: '4px 12px', marginRight: '12px', borderRadius: 'var(--radius64)', backgroundColor: yogaCenterId === id ? 'var(--baseblack)' : 'var(--basewhite)', border: yogaCenterId === id ? 'none' : '1px solid var(--secondarys300)' }}>
                        {label}
                    </div>)}
            </Flex>
            {!isFetchingLectures && wellnessLectures ? (<>
                <LectureCardInReservation dataList={wellnessLectures} />
            </>
            ) : (
                <WellnessLectureSkeleton />
            )}
        </div>
        <GnbFooter activeButton='explore' />
    </>
}

export { Explore }